import { SystemUserType } from "./SystemModels";

export class UserCredential {
    public username: string = "";
    public password: string = "";
}

export class UserAuthenticationResult {
    public success: boolean = false;
    public error: string = "";
}

export class LoginRequestResponse {
    public success: boolean = false;
    public actionType: LoginActionType = LoginActionType.Empty;
    public userType: SystemUserType = SystemUserType.Private;
    public message: string = "";
}

export enum LoginActionType {
    Empty,
    Redirect,
    SetPassword,
    Ctx,
    PrivateUserLoginForbidden
}